import {App} from "@src/App";
import React from "react";
import ReactDOM from "react-dom/client";
import "@src/ui/styles/globals.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App/>);
